import { render, staticRenderFns } from "./amz_subject.vue?vue&type=template&id=c05f149a&scoped=true&"
import script from "./amz_subject.vue?vue&type=script&lang=js&"
export * from "./amz_subject.vue?vue&type=script&lang=js&"
import style0 from "./amz_subject.vue?vue&type=style&index=0&id=c05f149a&scoped=true&lang=css&"
import style1 from "./amz_subject.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f149a",
  null
  
)

export default component.exports